if (!window.__tabsInitialized) {
  window.__tabsInitialized = true;

  document.addEventListener("DOMContentLoaded", function () {
    if (window.innerWidth > 991) {
      initCarousels();
      initTabs();
    } else {
      initMobileCarousels();
      initTabs();
    }
  });

  function initMobileCarousels() {
    const containers = document.querySelectorAll('.js-mobile-carousel:not([data-initialized])');
    const progressBars = document.querySelectorAll('.js-scroll-bar:not([data-initialized])');

    containers.forEach((container, index) => {
      container.setAttribute('data-initialized', 'true');
      const progressBar = progressBars[index];
      progressBar.setAttribute('data-initialized', 'true');

      container.addEventListener('scroll', () => {
        const scrollLeft = container.scrollLeft;
        const scrollWidth = container.scrollWidth - container.clientWidth;
        const scrollPercentage = (scrollLeft / scrollWidth) * 100;

        if (progressBar) {
          progressBar.style.width = `${scrollPercentage}%`;
        }
      });
    });
  }

  function initCarousels() {
    document.querySelectorAll(".js-products-carousel").forEach((element, index) => {
      if (!element.__splideInstance) {
        const uniqueClass = `js-products-carousel-${String(index + 1).padStart(2, "0")}`;
        element.classList.add(uniqueClass);

        const splide = new Splide(element, {
          type: 'slide',
          drag: 'free',
          gap: '60px',
          perPage: 5,
          rewind: false,
          arrows: false,
          pagination: false,
          breakpoints: {
            767: { perPage: 1, gap: '20px' },
            991: { perPage: 2, gap: '20px' },
            1298: { perPage: 4, gap: '40px' },
            1440: { perPage: 5, gap: '60px' }
          }
        });

        splide.mount();

        element.__splideInstance = splide;
      }
    });
  }

  function destroyCarousels() {
    document.querySelectorAll(".js-products-carousel").forEach(element => {
      if (element.__splideInstance) {
        element.__splideInstance.destroy();
        element.__splideInstance = null;
      }
    });
  }

  function initTabs() {
    document.querySelectorAll(".js-tab-link").forEach(tabLink => {
      tabLink.addEventListener("click", function (event) {
        event.preventDefault();

        setActiveTab(this);
      });
    });
  }

  function setActiveTab(tabLink) {
    const tabsContainer = tabLink.closest(".js-product-tabs");

    if (tabsContainer) {
      tabsContainer.querySelectorAll(".js-tab-link").forEach(link => link.classList.remove("active"));
      tabLink.classList.add("active");

      const index = tabLink.getAttribute("data-index");
      tabsContainer.querySelectorAll(".js-tab").forEach(tab => tab.classList.remove("active"));
      const activeTab = tabsContainer.querySelector(`.js-tab[data-index="${index}"]`);

      if (activeTab) {
        activeTab.classList.add("active");
        if (window.innerWidth > 991) {
          refreshCarouselInTab(activeTab);
        }
      }
    }
  }

  function refreshCarouselInTab(tab) {
    const carousel = tab.querySelector(".js-products-carousel");
    if (carousel && carousel.__splideInstance) {
      carousel.__splideInstance.destroy();
      carousel.__splideInstance.mount();
    } else if (carousel) {
      initCarousels();
    }
  }

  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      destroyCarousels();
      initCarousels();
      refreshTabs(event);
    });
    document.addEventListener('shopify:section:unload', function() {
      destroyCarousels();
      initCarousels();
    });
    document.addEventListener('shopify:section:select', function(event) {
      refreshTabs(event);
    });
    document.addEventListener('shopify:section:deselect', function() {
      destroyCarousels();
      initCarousels();
    });
    document.addEventListener('shopify:block:select', function(event) {
      const blockId = event.detail.blockId;
      const activeBlock = document.querySelector(`[data-block-id="${blockId}"]`);
      if (activeBlock) {
        const tabLink = document.querySelector(`.js-tab-link[data-block-id="${blockId}"]`);
        if (tabLink) {
          setActiveTab(tabLink);
        }
      }
    });
    document.addEventListener('shopify:block:deselect', function() {
      destroyCarousels();
      initCarousels();
    });
  }

  function refreshTabs(event) {
    const section = event.target.closest(".js-product-tabs");
    if (section) {
      const activeTabLink = section.querySelector(".js-tab-link.active");
      if (activeTabLink) {
        setActiveTab(activeTabLink);
      } else {
        const firstTabLink = section.querySelector(".js-tab-link");
        if (firstTabLink) {
          setActiveTab(firstTabLink);
        }
      }
    }
  }
}